import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { OriginIdService } from '../services/realtime/origin-id.service';

// The backend publishes this as `IChecklistChangePublisher.OriginIdHeader`. Keep the names in sync.
const ORIGIN_ID_HEADER = 'X-Origin-Id';

export function originIdInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) {
  const { originId } = inject(OriginIdService);
  return next(
    req.clone({ headers: req.headers.set(ORIGIN_ID_HEADER, originId) })
  );
}
